const HelpIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9097 4.69668C12.7128 2.84043 11.1941 1.32168 9.28156 1.06855C7.53782 0.871679 5.90657 1.74355 5.11907 3.2623C4.95032 3.57168 5.09094 3.96543 5.40032 4.10605C5.70969 4.2748 6.10344 4.13418 6.24407 3.8248C6.80657 2.75605 7.93157 2.16543 9.14094 2.27793C10.4628 2.44668 11.5034 3.51543 11.6441 4.78105C11.7847 5.99043 11.1378 7.14355 10.0409 7.6498C8.88782 8.2123 8.15657 9.39355 8.15657 10.7154V13.4998C8.15657 13.8373 8.43781 14.1467 8.80344 14.1467C9.16906 14.1467 9.45031 13.8654 9.45031 13.4998V10.7154C9.45031 9.8998 9.92844 9.14043 10.6316 8.80293C12.1784 8.12793 13.1066 6.44043 12.9097 4.69668Z"
        fill="currentColor"
      />
      <path
        d="M8.80312 15.5254C8.46562 15.5254 8.15625 15.8066 8.15625 16.1723V16.3129C8.15625 16.6504 8.4375 16.9598 8.80312 16.9598C9.16875 16.9598 9.45 16.6785 9.45 16.3129V16.1723C9.42187 15.8066 9.14063 15.5254 8.80312 15.5254Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HelpIcon;
